var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-name small-12 columns" },
    [
      _c("label", [_vm._v(_vm._s(_vm.$t("settings.user.vendor.userType")))]),
      _vm._v(" "),
      _c("HKLMultiSelect", {
        staticClass: "small-5 columns",
        attrs: {
          options: _vm.vendorTypeOptions,
          value: _vm.vendorParams.vendorType,
        },
        on: {
          change: function (val) {
            return _vm.updateUserType(val)
          },
        },
      }),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.$t("tenancy.companyId")))]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("HKLInput", {
            class: "small-9 columns",
            attrs: { type: "text" },
            model: {
              value: _vm.vendorParams.companyId,
              callback: function ($$v) {
                _vm.$set(_vm.vendorParams, "companyId", $$v)
              },
              expression: "vendorParams.companyId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.companyName")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "company-name-search-attribute" },
        [
          _c("HKLInput", {
            class: "small-9 columns",
            attrs: { type: "text" },
            model: {
              value: _vm.vendorParams.companyName,
              callback: function ($$v) {
                _vm.$set(_vm.vendorParams, "companyName", $$v)
              },
              expression: "vendorParams.companyName",
            },
          }),
          _vm._v(" "),
          _c("HKLButton", {
            attrs: {
              color: "darkblue",
              action: "search",
              disabled: _vm.isVendorTypeEmpty,
            },
            on: {
              click: function ($event) {
                return _vm._searchRecipients(false)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "filterRemoveConfirmModal",
        staticClass: "ecircular-modal",
        attrs: {
          modalId: _vm.filterRemoveConfirmModalId,
          "confirm-title": "eCircular.confirmRemoveUserTypeBody",
          "modal-type": "small-modal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }